export default "__VITE_ASSET__a33087dc__"